import { DataVisualizationType } from "components/charting/config/chartTypes";
import {
  SelectedChartMeasure,
  SelectedChartMeasureEmpty,
  SelectedChartMeasureExercise,
} from "components/charting/types";
import Constants from "config/Constants";
import ExerciseHelpers from "helpers/ExerciseHelpers";
import { MetadataType } from "types/metadata";
import { TimePeriod } from "types/period";

class MeasureHelpers {
  static getValidMeasures(measures: SelectedChartMeasure[]) {
    return measures.reduce<Exclude<SelectedChartMeasure, SelectedChartMeasureEmpty>[]>((acc, measure) => {
      if (measure.type === null) return acc;

      acc.push(measure);

      return acc;
    }, []);
  }

  static get1RMLineMeasures(measures: SelectedChartMeasure[]) {
    return measures.filter((measure) => {
      return measure.type === MetadataType.EXERCISE && ExerciseHelpers.isOneRepMaxExercise(measure.metadata);
    }) as SelectedChartMeasureExercise[];
  }

  static getCommonProperties(measure: Exclude<SelectedChartMeasure, SelectedChartMeasureEmpty>) {
    if (measure.type === MetadataType.EXERCISE) {
      return {
        id: measure.id,
        entityId: [measure.id, measure.metric.field].join("-"),
        type: measure.type,
        label: measure.metadata.name,
        subLabel: measure.metric.name,
        metricField: measure.metric.field,
      };
    }

    if (measure.type === MetadataType.WELLNESS) {
      return {
        id: measure.id,
        entityId: measure.id,
        type: measure.type,
        label: measure.type,
        subLabel: measure.metadata.name,
      };
    }

    if (measure.type === MetadataType.SCORE) {
      return {
        id: measure.id,
        entityId: measure.id,
        type: measure.type,
        label: measure.type,
        subLabel: measure.metadata.name,
      };
    }

    if (measure.type === MetadataType.CIRCUIT) {
      return {
        id: measure.id,
        entityId: [measure.id, measure.metric.field].join("-"),
        type: measure.type,
        label: measure.metadata.name,
        subLabel: measure.metric.name,
        metricField: measure.metric.field,
      };
    }

    return {
      id: measure.id,
      entityId: measure.id,
      type: measure.type,
      label: measure.type,
      subLabel: measure.metadata.label,
    };
  }

  static getAthleteProfileChartUrl(
    athleteId: string,
    params: {
      visType?: DataVisualizationType;
      metadataId: string;
      start?: string;
      end?: string;
      interval?: TimePeriod | "custom";
    }
  ): string {
    const queryString = Object.entries(params)
      .filter(([value]) => value)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");
    return `${Constants.routes.athletes.route}/${athleteId}?${queryString}`;
  }
}
export default MeasureHelpers;
